<template>
  <div class="userManage">
    <div class="search">
      <div class="search_box">
        <div class="search_options_box">
          <span style="width: auto;white-space: nowrap">选择项目</span>
          <img src="/static/img/select.png" alt />
          <select >
            <!-- <option v-for="item in projectList" v-bind:value="item.id" v-bind:key="item.id" >{{ item.name }}</option> -->
          </select>
        </div>

        <div class="search_btn_box">
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="search()"><span class="el-icon-search"></span>搜索</button>
          </div>
        </div>

        <div class="add_btn_box">
          <button :class='["add_btn","add","icon_btn","clearborder"]'  @click="addUserBtn"><span class="icon-9"></span>新增用户</button>
          <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="batchDeleteUser(null)"><span class="icon-9"></span>批量删除</button>
        </div>
      </div>
    </div>
    <!--        表格-->
    <div class="table_content">
      <table>
        <thead>
          <tr>
            <th style="padding-left: 30px">
              <input type="checkbox" name="checkbox" style="width: 16px;height: 16px" />
            </th>
            <th>序号</th>
            <th>登录账号</th>
            <th>用户名</th>
            <th>角色</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>最近修改时间</th>
            <th>管理</th>
          </tr>
        </thead>
        <tbody v-for="(item,index) in currentPageData" :key="index">
          <tr>
            <td style="padding-left: 30px">
              <input type="checkbox" name="checkbox" v-model="selectedUsers" :value="item.id"/>
            </td>
            <td>{{index+1}}</td>
            <td>{{item.name}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.role}}</td>
            <td v-if="item.status==='0'">禁用</td>
            <td v-if="item.status==='1'">启用</td>
            <td>{{item.create_datetime}}</td>
            <td>{{item.update_datetime}}</td>
            <td class="table_btn_box">
              <button class="table_btn" style=" margin-right: 20px;" @click="updateUserBtn(item)">编辑</button>
              <button class="table_btn" @click="deleteUser(item.id)">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
   <div class="table_paging">
        <p>当前记录<span>{{(this.currentPage-1)*9+1}}</span>到<span>{{(this.currentPage-1)*9+this.currentPageData.length}}</span>条，共<span>{{this.totalCount}}</span>条记录
          <button @click="FirstPage()"
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            @click="prevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>{{currentPage}}</span>/<span>{{Math.ceil(totalCount/pageSize)}}</span>页
          <button
            @click="nextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button @click="LastPage()"
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
    </div>
    <!--    添加用户-->
    <transition name="fade">
      <div class="mark" v-if="addUserShow">
        <div class="mark_close" @click="addUserShow=!addUserShow"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model" >
            <h1>添加用户</h1>
            <label>登录账号：</label><input type="text" v-model="currentUser.name" class="input_border" placeholder="请输入用户名称"><br>
            <label>用户名：</label><input type="text" v-model="currentUser.mobile" class="input_border" placeholder="请输入手机号"><br>
            <label>密码：</label><input type="text" v-model="currentUser.password" class="input_border" placeholder="请输入用户名称"><br>
            <label>用户状态：</label><input type="text" v-model="currentUser.status" class="input_border" placeholder="请输入用户名称"><br>
            <label class="js">所属角色：</label>
            <select v-for="(item,index) in roleList" :key="index" v-model="currentUser.role_id" class="input_border select_width" >
              <option :value ="item.id">{{item.name}}</option>
            </select>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="addUserShow=!addUserShow">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="confirmAddUser()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--    修改用户-->
    <transition name="fade">
      <div class="mark" v-if="updateUserShow">
        <div class="mark_close" @click="updateUserShow=!updateUserShow"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>修改用户</h1>
            <label>用户名称：</label><input type="text" v-model="currentUser.name" class="input_border" placeholder="请输入用户名称"><br>
            <label>手机号：</label><input type="text" v-model="currentUser.mobile" class="input_border" placeholder="请输入用户名称"><br>
            <label>用户状态：</label><input type="text" v-model="currentUser.status" class="input_border" placeholder="请输入用户名称"><br>
            <label>所属角色：</label>
            <select v-for="(item,index) in roleList" :key="index" v-model="currentUser.role_id" class="input_border select_width1">
              <option :value ="item.id">{{item.name}}</option>
            </select>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="updateUserShow=!updateUserShow">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="confirmUpdateUser()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "userManage",
  data() {
    return {
      totalCount: 0, // 总记录条数
      pageSize: 9, // 每页显示数量
      currentPage: 1, //当前页数 ，默认为1
      currentPageData: [],
      addUserShow:false,
      updateUserShow:false,
      currentUser:{user_id:"",name:"",mobile:"",password:"",status:"",role_id:""},
      roleList:[],
      selectedUsers:[]
    };
  },
  methods: {
    batchDeleteUser: function (user_id) {
      var user_list = [];
      if(user_id == null){
        user_list = this.selectedUsers;
      }else{
        user_list = [user_id];
      }
      fetch("/api/v1/user/delete", {
        method: 'post',
        body: JSON.stringify({
          user_id: user_list
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.getUserList();
          } 
      }).catch((error) => {
          console.log(error);
      });
    },    
    deleteUser: function (user_id) {
      this.batchDeleteUser(user_id)
    },
    confirmAddUser: function () {
      fetch("/api/v1/user/add", {
        method: 'post',
        body: JSON.stringify({
          name: this.currentUser.name,
          mobile: this.currentUser.mobile,
          password: this.currentUser.password,
          status: this.currentUser.status,
          role_id: this.currentUser.role_id,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.getUserList();
          } 
      }).catch((error) => {
          console.log(error);
      });
      this.addUserShow=!this.addUserShow;
    },
    confirmUpdateUser: function () {
      fetch("/api/v1/user/update", {
        method: 'post',
        body: JSON.stringify({
          user_id: this.currentUser.user_id,
          name: this.currentUser.name,
          mobile: this.currentUser.mobile,
          status: this.currentUser.status,
          role_id: this.currentUser.role_id,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            console.log(data.msg);
            this.getUserList();

          } 
      }).catch((error) => {
          console.log(error);
      });
      this.updateUserShow=!this.updateUserShow;
    },
    addUserBtn:function(){
        this.addUserShow=!this.addUserShow;
        this.getRoleList();
    },
    updateUserBtn:function(user){
        this.updateUserShow=!this.updateUserShow;
        this.getRoleList();
        this.currentUser.user_id=user.id,
        this.currentUser.name=user.name,
        this.currentUser.mobile=user.mobile,
        this.currentUser.status=user.status,
        this.currentUser.role_id=user.role_id
    },
    getUserList: function () {
      fetch("/api/v1/user/list", {
        method: 'post',
        body: JSON.stringify({
          page_start: this.currentPage-1,
          page_size: this.pageSize,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.totalCount = data.total_count;
            this.currentPageData = data.data;
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
    getRoleList: function () {
      fetch("/api/v1/sys/role/list", {
        method: 'post',
        body: JSON.stringify({
          page_start: this.currentPage-1,
          page_size: 2000,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.roleList = data.data;
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
    //上一页
    prevPage() {
      if (this.currentPage == 1) {
        return false;
      } else {
        this.currentPage--;
        this.getUserList();
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage == Math.ceil(this.totalCount/this.pageSize)) {
        return false;
      } else {
        this.currentPage++;
        this.getUserList();
      }
    },
    FirstPage(){
        this.currentPage = 1;
        this.getUserList();
    },
    LastPage(){
      this.currentPage = Math.ceil(this.totalCount/this.pageSize);
      this.getUserList();
    },
  },
  mounted() {
    // this.InitLeftMenu();
    this.getUserList();
  },
  created() {},
  destroyed: function() {}
};
</script>

<style scoped>
.userManage {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.search {
  width: 100%;
  height: 100px;
  padding: 20px 0px 0px;
}

.search_box {
  width: 100%;
  height: 100%;
  margin-right: 10px;
  background: #16518d;
  border-radius: 6px;
  float: left;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}

.search_options_box {
  width: 16%;
  padding: 0 10px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.search_options_box > span {
  width: 64px;
  margin-right: 8px;
  text-align: right;
  color: #ffffff;
}

.search_options_box > select {
  width: calc(100% - 72px);
  height: 36px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid #ffffff;
  color: #ffffff;
  appearance: none;
  padding-left: 10px;
  font-size: 16px;
  outline: none;
  cursor: pointer;
}

.search_options_box option {
  color: #000000;
}

.search_options_box > img {
  position: absolute;
  top: 48px;
  right: 20px;
  cursor: pointer;
}

.search_btn_box {
  width: 80px;
  padding: 10px;
}

.clearborder {
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search_btn {
  width: 100%;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
}

.add_btn {
  width: 110px;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
  float: right;
  margin-right: 20px;
}

.icon_btn span {
  margin-right: 8px;
}

.green {
  background: #21b868;
  color: #ffffff;
}

.green:active {
  background: #15a95a;
}

.add_btn_box {
  /*width: 370px;*/
  padding: 10px;
  position: absolute;
  right: 0px;
}

.add {
  background: #7aafeb;
  color: #ffffff;
  box-shadow: 0px 3px 0px #3574ba;
}

.add:active {
  background: #6ca3e2;
}

.delete {
  background: #f2ae4d;
  color: #ffffff;
  box-shadow: 0px 3px 0px #dc8509;
}

.delete:active {
  background: #e7a342;
}
.table_content {
  width: 100%;
  padding: 20px 0px;
}

.table_content > table {
  width: 100%;
  height: 100%;
  border: 1px solid #094b8e;
  background-color: #16518d;
}

.table_content > table tr th {
  background-color: #0e345b;
}
/* .table_content > table tr td {
  background-color: #16518d;
} */

.table_content > table tr td input {
  width: 16px;
  height: 16px;
}

.table_content > table tr:nth-child(2n) {
  background-color: #11406f;
}

.table_content > table tr {
  /*border-bottom: 1px solid #225892;*/
  height: 62px;
}

.table_content > table tr td,
.table_content > table tr th {
  text-align: center;
  color: #ffffff;
}

.table_paging {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #105ba8;
  border-radius: 6px;
}

.table_paging > p {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: right;
  margin-bottom: 0;
  color: #c1c2c6;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}

.table_paging > p > button {
  margin: 0 8px;
  width: 10px;
  height: 16px;
  border: none;
  outline: none;
}

.table_btn {
  color: #95bee5;
  background: transparent;
  border: 1px solid #95bee5;
  outline: transparent;
  padding: 5px 20px;
  border-radius: 6px;
}
.information_content label{
  width: 20% !important;
  text-align: right;
  color: #ffffff;
}
.information_content .js{
  width: 19% !important;
  text-align: right;
  color: #ffffff;
}
.input_border{
  border-radius: 4px;
  border:1px solid #556e88 !important;
  background:none;
  padding-left: 10px;
  height: 32px;
  margin: 10px 0 10px 0;
  width: 73%;
  color:#ffffff;
}
.select_width{
  width:76%;
}
.select_width1{
  width:74.5%;
}
.information_content select{
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/Setting/user_manage.vue